import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import SmoothScroll from "@/components/SmoothScroll";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Listings from "@/pages/Listings";
import Insights from "@/pages/Insights";
import Contact from "@/pages/Contact";
import Financing from "@/pages/Financing";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";
import { AuthProvider } from "@/lib/auth";

function App() {
  return (
    <div className="App grain bg-[#FAFAF9] text-[#0E1B2E]">
      <AuthProvider>
        <BrowserRouter>
          <SmoothScroll>
            <Nav />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/aircraft" element={<Listings />} />
              <Route path="/insights" element={<Insights />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/financing" element={<Financing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/private-aviation/*" element={<Navigate to="/" replace />} />
            </Routes>
            <Footer />
          </SmoothScroll>
        </BrowserRouter>
      </AuthProvider>
      <Toaster theme="light" position="bottom-right" toastOptions={{ style: { background: "#FFFFFF", color: "#0E1B2E", border: "1px solid rgba(200,169,126,0.35)" } }} />
    </div>
  );
}

export default App;
